// extracted by mini-css-extract-plugin
export default {"headerBar":"EditUser_headerBar__nt92m"};